import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { acceptHostRequest } from "../../store/hostRequest/action";
import male from "../../assets/images/male.png";
import timeIcon from "../../assets/images/time.png";
import ReasonDialogue from "./ReasonDialogue";
import { permissionError } from "../../util/Alert";
import useTranslation from "../../hooks/useTranslation";
import { T, glassCard } from "../../util/theme";

const Pending = () => {
  const { t } = useTranslation();
  const { request } = useSelector((state) => state.hostRequest);
  const admin = useSelector((state) => state.admin.seller);
  const dispatch = useDispatch();

  const handleAccept = (id) => {
    if (admin?.isActive === false) return permissionError();
    dispatch(acceptHostRequest(id, "accept"));
  };

  const handleDecline = (id) => {
    if (admin?.isActive === false) return permissionError();
    dispatch(acceptHostRequest(id, "decline"));
  };

  const fmtDate = (d) =>
    (d ? new Date(d) : new Date())
      .toLocaleDateString("en-GB")
      .replace(/\//g, "-");

  return (
    <>
      {request?.length > 0 ? (
        <div className="pending-list" style={{ padding: "4px 0" }}>
          {request.map((data, index) => (
            <div
              key={data?._id || index}
              style={{
                ...glassCard,
                padding: 16,
                marginBottom: 12,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 12,
                }}
              >
                <div
                  style={{ display: "flex", gap: 12, flex: 1, minWidth: 0, alignItems: "center" }}
                >
                  <img
                    src={data?.user?.image || male}
                    alt=""
                    style={{
                      height: 48,
                      width: 48,
                      objectFit: "cover",
                      borderRadius: "50%",
                      flexShrink: 0,
                    }}
                  />
                  <div style={{ minWidth: 0 }}>
                    <div
                      style={{
                        fontWeight: 800,
                        fontSize: 14,
                        color: "#fff",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {data?.name || "-"}
                    </div>
                    <div style={{ color: "#FFFFFFA3", fontWeight: 400, fontSize: 12, marginTop: 3 }}>
                      {t("ID")}: {data?.user?.uniqueId || "-"}
                    </div>
                  </div>
                </div>

                <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
                  <button
                    type="button"
                    onClick={() => handleAccept(data?._id)}
                    style={{
                      background: "#00E95929",
                      border: "none",
                      borderRadius: 12,
                      width: 40,
                      height: 40,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      padding: 0,
                      lineHeight: 0,
                    }}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#00E959"
                      strokeWidth="2.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={{ display: "block", flexShrink: 0 }}
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </button>
                  <button
                    type="button"
                    onClick={() => handleDecline(data?._id)}
                    style={{
                      background: "#FF000029",
                      border: "none",
                      borderRadius: 12,
                      width: 40,
                      height: 40,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      padding: 0,
                      lineHeight: 0,
                    }}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#FF0000"
                      strokeWidth="2.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={{ display: "block", flexShrink: 0 }}
                    >
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                  </button>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  marginTop: 14,
                  paddingTop: 12,
                  borderTop: `1px solid #FFFFFF2B`,
                }}
              >
                <div
                  style={{
                    width: 34,
                    height: 34,
                    borderRadius: 10,
                    background: T.iconBox,
                    display: "grid",
                    placeItems: "center",
                    flexShrink: 0,
                  }}
                >
                  <img
                    src={timeIcon}
                    alt=""
                    width={14}
                    height={14}
                    style={{ objectFit: "contain", display: "block" }}
                  />
                </div>
                <span style={{ color: "#FFFFFFA3", fontSize: 14, fontWeight: 400, flex: 1, lineHeight: "17px" }}>
                  {t("pending_approval")}
                </span>
                <span style={{ color: "#fff", fontWeight: 700, fontSize: 14, lineHeight: "17px" }}>
                  {fmtDate(data?.createdAt || data?.date)}
                </span>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <EmptyState title={t("no_pending")} subtitle={t("no_pending_application")} />
      )}
      <ReasonDialogue />
    </>
  );
};

const EmptyState = ({ title, subtitle }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "55vh",
      padding: "24px 20px",
      textAlign: "center",
      border: "none",
      background: "transparent",
    }}
  >
    <div style={{ color: "#fff", fontSize: 18, fontWeight: 600, marginBottom: 8 }}>{title}</div>
    <div style={{ color: T.sub, fontSize: 14, fontWeight: 400, maxWidth: 300 }}>{subtitle}</div>
  </div>
);

export default Pending;
